module.exports = __webpack_public_path__ + "img/metier_visiteur_update.7d8f20f9.png";